import { inject, injectable } from "inversify";
import { CalendarEventModel, CaseModel, DailyItineraryItemModel, ICPLDashboardClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IDashboardService {
  getDailyItinerary(): Promise<DailyItineraryItemModel[]>;
  getWeeklyMeetings(): Promise<CalendarEventModel[]>;
  getActionableCases(): Promise<CaseModel[]>;
}

@injectable()
export class DashboardService implements IDashboardService {
  @inject(SERVICE_TYPES.CPLDashboardClient) cplDashboardClient!: ICPLDashboardClient;

  async getDailyItinerary(): Promise<DailyItineraryItemModel[]> {
    return this.cplDashboardClient.getDailyItinerary();
  }

  async getWeeklyMeetings(): Promise<CalendarEventModel[]> {
    return this.cplDashboardClient.getWeeklyMeetings();
  }

  async getActionableCases(): Promise<CaseModel[]> {
    return this.cplDashboardClient.getActionableCases();
  }
}
